import React from 'react';
import { useGlobalDialogContext } from 'App/components/Layouts/Dashboard/dialog/GlobalDialog';
import { ConfirmPurgeDriverDialog } from './index';
import candidateService from 'store/candidate/service';

export const ConfirmPurgeDriverGlobalDialog = ({
  candidateId,
  candidateFullName,
}: any) => {
  const { hideDialog } = useGlobalDialogContext();

  const [purgeDriver, { isLoading, isSuccess }] =
    candidateService.endpoints.purgeDriver.useMutation();

  const handleDialogToggle = () => {
    hideDialog();
  };

  const handlePurge = () => {
    purgeDriver({ candidateId });
  };

  return (
    <ConfirmPurgeDriverDialog
      open={true}
      setOpen={() => {
        handleDialogToggle();
      }}
      isLoading={isLoading || isSuccess}
      isSuccess={isSuccess}
      candidateFullName={candidateFullName}
      onPurge={handlePurge}
    />
  );
};
